import { z } from "zod/v4-mini";

import { TandemCommand, TandemResponse } from "@/lib/drivers/tandem/TandemTypes";
import { Schema } from "@/utils/zodUtils";

export type MaxBolusPayload = {
  max_bolus_setting_milliunits: number;
};

export type MaxBolus = {
  maxBolusSettingMilliUnits: number;
  maxBolusSettingUnits: number;
};

export const maxBolusPayloadSchema: Schema<MaxBolusPayload> = z.object({
  max_bolus_setting_milliunits: z.number(),
});

export const MAX_BOLUS_RESPONSE = {
  value: 246,
  name: "Max Bolus Message",
  format: "s",
  fields: ["max_bolus_setting_milliunits"] as const,
  postprocess: rec => ({
    maxBolusSettingMilliUnits: rec.max_bolus_setting_milliunits,
    maxBolusSettingUnits: rec.max_bolus_setting_milliunits * 0.001,
  }),
  schema: maxBolusPayloadSchema,
} as const satisfies TandemResponse<MaxBolusPayload, MaxBolus>;

export const MAX_BOLUS_COMMAND = {
  value: 245,
  name: "Max Bolus Request",
  response: MAX_BOLUS_RESPONSE,
} as const satisfies TandemCommand<MaxBolusPayload, MaxBolus>;
